import axios from 'axios';

export const uploadFile = (file: File | undefined | null, url: string | undefined | null) => {
    if (!file) return Promise.reject();

    let data: File | FormData = file;
    let contentType = file.type;
    if (!contentType) {
        contentType = 'multipart/form-data';
        data = new FormData();
        data.append('file', file);
    }

    if (!url) return Promise.reject();
    return axios.put(url, data, {
        headers: { 'Content-Type': contentType },
    });
};
